import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

export default function Navbar(props) {
  return (
    <nav
      className={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode}`}
    >
      <div className="container-fluid">
        <Link className="navbar-brand" to="/">
          {props.title}
        </Link>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse " id="navbarSupportedContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <Link className="nav-link active" aria-current="page" to="/">
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link active" to="/about">
                {props.aboutText}
              </Link>
            </li>
          </ul>
          <form className="d-flex">
            <input
              className="form-control me-2 rounded-pill"
              type="search"
              placeholder="Search"
              aria-label="Search"
            />
            <button className="btn btn-primary rounded-pill" type="submit">
              Search
            </button>
          </form>
          <div className="d-flex">
            <div className="bg-primary rounded mx-2 my-2" style={{height:'30px', width:'30px', cursor:'pointer', border:'solid 2px'}} onClick={() => {props.toggleMode('primary')}}></div>
          </div>
          <div className="d-flex">
            <div className="bg-danger rounded mx-2 my-2" style={{height:'30px', width:'30px', cursor:'pointer', border:'solid 2px'}} onClick={() => {props.toggleMode('danger')}}></div>
          </div>
          <div className="d-flex">
            <div className="bg-success rounded mx-2 my-2" style={{height:'30px', width:'30px', cursor:'pointer', border:'solid 2px'}} onClick={() => {props.toggleMode('success')}}></div>
          </div>
          <div className="d-flex">
            <div className="bg-warning rounded mx-2 my-2" style={{height:'30px', width:'30px', cursor:'pointer', border:'solid 2px'}} onClick={() => {props.toggleMode('warning')}}></div>
          </div>
          <div className="d-flex">
            <div className="bg-light rounded mx-2 my-2" style={{height:'30px', width:'30px', cursor:'pointer', border:'solid 2px'}} onClick={() => {props.toggleMode('light')}}></div>
          </div>
          <div className="d-flex">
            <div className="bg-dark rounded mx-2 my-2" style={{height:'30px', width:'30px', cursor:'pointer', border:'solid white 2px'}} onClick={() => {props.toggleMode('dark')}}></div>
          </div>

          {/* <div className={`form-check form-switch mx-2 my-2 text-${props.mode === 'light'?'dark':'light'}`}>
            <input
              className="form-check-input"
              type="checkbox"
              role="switch"
              id="flexSwitchCheckDefault"
              onClick={() => {props.toggleMode(null)}}
            />
            <label
              className="form-check-label"
              htmlFor="flexSwitchCheckDefault"
            >
              Toggle Mode
            </label>
          </div> */}
        </div>
      </div>
    </nav>
  );
}

Navbar.propTypes = {
  title: PropTypes.string.isRequired,
  aboutText: PropTypes.string.isRequired,
};

Navbar.defaultProps = {
  title: "Set title here",
  aboutText: "About TextUtils",
};
